import * as React from 'react';

import { breakpoints } from '@notino/react-styleguide';
import {
  GetCatalogProductViewQuery,
  ProductIdType,
} from '@notino/shared/definitions/types';

import { styled } from '@linaria/react';

import messages from '../../messages';
import { ProductsSection, VpProductItem } from '../ProductsSection';

import { LIST_LABEL } from './constants';
import { useLastVisitedVariants } from './useLastVisitedVariants';

interface ILastVisitedProductsProps {
  variants: NonNullable<
    GetCatalogProductViewQuery['productDetailByCatalogMasterId']
  >['variants'][number][];
}

const Wrap = styled.div`
  margin-bottom: 2rem;
  @media (min-width: ${breakpoints.lg}) {
    margin-bottom: 4rem;
  }
`;

// Show the viewed variant when it is available or sold out (watchdog), but not
// when its sale has ended (canBuy === false && showWatchdog === false).
const isNotDiscontinued = (product: VpProductItem) =>
  product.canBuy || product.showWatchdog;

export const LastVisitedProducts: React.FC<ILastVisitedProductsProps> = ({
  variants,
}) => {
  const excludeCatalogIds = React.useMemo(
    () => variants.map((variant) => String(variant.catalogId)),
    [variants]
  );
  const items = useLastVisitedVariants(excludeCatalogIds);

  if (!items || !items.length || items.length < 3) {
    return null;
  }

  return (
    <Wrap>
      <ProductsSection
        productIds={items}
        idType={ProductIdType.Catalog}
        filterProducts={isNotDiscontinued}
        titleMessage={messages.lastVisited}
        titleId="pdLastVisitedProducts"
        containerId="pd-last-visited-products-header"
        listLabel={LIST_LABEL}
        trackProductClick={true}
        trackProductImpression={true}
      />
    </Wrap>
  );
};
